/**
 * Shared Sentry configuration for the frontend runtimes.
 *
 * Environment: `SENTRY_ENVIRONMENT` wins when the runtime exposes it. Server
 * and edge processes read it from `process.env`; the browser bundle only sees
 * `NODE_ENV` because Next inlines public values at build time. Without an
 * override, `NODE_ENV=production` resolves `production` and every other value
 * resolves `development`.
 *
 * DSN: server and edge read `SENTRY_DSN` when it is defined, fall back to the
 * built-in DSN when it is unset, and disable reporting when it is empty. The
 * browser bundle always uses the built-in DSN.
 *
 * Components: each init module tags its events with its own component name.
 */

export const BUILT_IN_SENTRY_DSN =
  "https://2c2cb617aa4de513a9abf584e56d14d6@o4511037517594624.ingest.de.sentry.io/4511037521854544";

export const SENTRY_COMPONENTS = {
  server: "frontend-server",
  edge: "frontend-edge",
  browser: "frontend-browser",
} as const;

type SentryEnv = {
  NODE_ENV?: string;
  SENTRY_ENVIRONMENT?: string;
  SENTRY_DSN?: string;
};

export function resolveSentryEnvironment(env: SentryEnv): string {
  if (env.SENTRY_ENVIRONMENT) {
    return env.SENTRY_ENVIRONMENT;
  }
  return env.NODE_ENV === "production" ? "production" : "development";
}

export function resolveSentryDsn(env: SentryEnv): string | undefined {
  const dsn = env.SENTRY_DSN ?? BUILT_IN_SENTRY_DSN;
  return dsn === "" ? undefined : dsn;
}
